// ------------------------------------------------------------------
// PURE MODULE: navbar.mod.js (formerly line_chapters_1.mod.js)
// ------------------------------------------------------------------
import gsap from "gsap"; 
import { MakeSvgEl } from '../utils/svgfuns.mod.js';
import { createWaveAnimation } from '../utils/svgwvs.mod.js';
import "./line_1.css";
import "./chapters_1.css";
import "./sound_1.css";

export function Navbar() {
  ///////////////////////// MODULE LOGIC AND CODE START /////////////////////////

  // --- [FIX] DEFINE VARIABLES AT THE TOP (Scope Safety) ---
  let soundMarkerIcon, ButtonIcon, soundAnim, WavesGroup, ButtonCover, ButtonTooltip; 
  let soundWavePath_on = null;
  let soundWavePath_off = null;
  let isSoundOn = true;
  // --------------------------------------------------------

  const config = {
   SvgEl: ".progress-line-svg",
   FgEl: "progress-line-fg",
   BgEl: "progress-line-bg",
   y12: 38,
   x2: 600,
   direction: {
    lineProgress: 1
  },
   chapters: {
    GroupClass: "progress-line-chapter-marker-group",
    ObodClass: "chapter-marker-circle",
    MainClass: "chapter-marker-circleic",
    IconTxtClass: "chapter-marker-text",
    ChTxtClass: "line-chapter-text",
//	dir: "shortest", // Options: "shortest", "forward"
	dir: "shortest", // Options: "shortest", "bounded"
  },
 };
  
  let lineLength;
  const lineSVG = document.querySelector(config.SvgEl);
  // [THE FIX] Wipe the SVG clean before adding new elements
//  if (lineSVG) lineSVG.innerHTML = '';

  const lineBG = MakeSvgEl('line',{ x1:0, y1:config.y12, x2:config.x2, y2:config.y12, class:config.BgEl });
  const lineFG = MakeSvgEl('line',{ x1:0, y1:config.y12, x2:config.x2, y2:config.y12, class:config.FgEl });
  lineSVG.append(lineBG,lineFG);

  if (lineFG) {
//    lineLength = lineFG.getTotalLength();
    lineLength = config.x2;
//	console.log(lineLength);
    gsap.set(lineFG, {
      strokeDasharray: lineLength,
      strokeDashoffset: lineLength
    });
  }
  
/*  function updateLineProgress(progressVal) {
  if (!lineFG || !lineLength) return; 

  let val = (typeof progressVal !== 'undefined') ? progressVal : 0;
  let linePercent = (val % 1 + 1) % 1;

  if (config.direction.lineProgress === -1) {      
    linePercent = 1 - linePercent;
  }
  const drawValue = `${linePercent * 100}%`;

  gsap.set(lineFG, {
    drawSVG: drawValue
  });
  updateChapterUI();
} */


function updateLineProgress(progressVal) {
  if (!lineFG || !lineLength) return; 

  let val = (typeof progressVal !== 'undefined') ? progressVal : 0;
  let linePercent = (val % 1 + 1) % 1;

  if (config.direction.lineProgress === -1) {      
    linePercent = 1 - linePercent;
  }
  
  // [MASTER MANAGER FIX]
  // Instead of just a percentage string, give GSAP the full context
  // so it doesn't "read" the DOM path length.
  gsap.set(lineFG, {
    drawSVG: `0% ${linePercent * 100}%`,
    // If you've hardcoded lineLength = 600 as we discussed, 
    // you can pass that in some GSAP versions or just ensure 
    // the path is not being re-measured.
  });
/*     gsap.set(lineFG, {
    drawSVG: `${linePercent * 100}%`,
    strokeDasharray: 600
  }); */
  
 // updateChapterUI();
 const currentSnap = Math.floor(linePercent * App.layout.numImages);
  if (this._lastSnap !== currentSnap) {
    updateChapterUI();
    this._lastSnap = currentSnap;
  }
 
}

/* function updateLineProgress(progressVal) {
  if (!lineFG || !lineLength) return; 

  let val = (typeof progressVal !== 'undefined') ? progressVal : 0;
  let linePercent = (val % 1 + 1) % 1;

  if (config.direction.lineProgress === -1) {      
    linePercent = 1 - linePercent;
  }

  gsap.set(lineFG, {
    drawSVG: `${linePercent * 100}%`,
    strokeDasharray: 600
  });

  // [MASTER MANAGER FIX] Only update the chapters when the rounded index changes
  const currentSnap = Math.floor(linePercent * App.layout.numImages);
  if (this._lastSnap !== currentSnap) {
    updateChapterUI();
    this._lastSnap = currentSnap;
  }
} */

//////////////////////////////
// --- CHAPTERS LOGIC ---
const chapters = []; 
//let lastActiveChapterId = null;
let lastActiveChapter = null;
const lineChapterText = document.querySelector(".line-chapter-text");
const chapterElements = document.querySelectorAll(".carousel-chapter");

// --- New Chapter UI Elements ---
setupSoundMarker();
setupChapterMarkers();
setupSoundTooltip();


function setupChapterMarkers() {
  if (chapterElements.length === 0) {return;}
  const fragment = document.createDocumentFragment();
  let currentImageIndex = 0;
  
  chapterElements.forEach((chapterEl, chapterIndex) => {
    const chapterImages = chapterEl.querySelectorAll(".carousel-image");
    const startIndex = currentImageIndex;
    const endIndex = currentImageIndex + chapterImages.length - 1; 
    
    // [NOTE] App.layout.numImages must be defined before this runs!
    // We fix this by moving the registration line in Master JS.
    const startProgress = startIndex / (App.layout.numImages || 1); // Fallback to 1 to prevent NaN crash
    
    const chapterName = chapterEl.dataset.chapterName || `Chapter ${chapterIndex + 1}`;
    
    const lineMarkerElems = {};
    const circleMarkerElems = {};

      let chapterPercent = startProgress;
      if (config.direction.lineProgress === -1) {chapterPercent = 1 - chapterPercent;}
      
      const xPos = chapterPercent * config.x2;
      
      const group = MakeSvgEl("g", {class: config.chapters.GroupClass,"data-chapter-id": chapterIndex + 1});
      const circle = MakeSvgEl('circle',{ cx:xPos, cy:config.y12, r:config.y12, class:config.chapters.ObodClass });
      const circleic = MakeSvgEl('circle',{ cx:xPos, cy:config.y12, r:config.y12/2, class:config.chapters.MainClass });
      const text = MakeSvgEl('text',{ x:xPos, y:config.y12, textContent: chapterIndex + 1, class:config.chapters.IconTxtClass });

      group.append(circle,circleic,text);
//      lineSVG.appendChild(group); 
	  fragment.appendChild(group); // Append to fragment, not the DOM

      group.addEventListener('click', () => goToChapter(chapterIndex + 1));
      
      lineMarkerElems.circle = circleic;
      lineMarkerElems.text = text;
  
    chapters.push({
      id: chapterIndex + 1, 
      name: chapterName, 
      startIndex: startIndex,
      endIndex: endIndex,
      startProgress: startProgress,
      markerElems: { 
        line: lineMarkerElems,
        circle: circleMarkerElems
      }
    });

    currentImageIndex += chapterImages.length;
  });
  
  lineSVG.appendChild(fragment); // ONE single DOM hit
}


/* function goToChapter(chapterId) {
  const chapter = chapters.find(c => c.id === chapterId);
  if (chapter) {
    const current = App.progress.value;
    const targetUnit = chapter.startProgress; 

    const currentRotation = Math.floor(current); 
    
    const targetM1 = (currentRotation - 1) + targetUnit; 
    const target0  = currentRotation + targetUnit;
    const target1  = (currentRotation + 1) + targetUnit; 

    const distM1 = Math.abs(current - targetM1); 
    const dist0  = Math.abs(current - target0);  
    const dist1  = Math.abs(current - target1);  

    let finalTargetValue = target0;
    if (distM1 < dist0 && distM1 < dist1) {
      finalTargetValue = targetM1;
    } else if (dist1 < dist0) {
      finalTargetValue = target1;
    }
    gsap.to(App.progress, {
      duration: 1.5, 
      ease: "power2.out",
      value: finalTargetValue
    });
  }
} */

/* function goToChapter(chapterId) {
  const chapter = chapters.find(c => c.id === chapterId);
  if (chapter) {
    const current = App.progress.value;
    const targetUnit = chapter.startProgress; 

    const currentRotation = Math.floor(current); 
    let finalTargetValue = currentRotation + targetUnit;

    // Check Config Direction (Default to 'shortest')
    const mode = config.chapters.dir || "shortest";

    if (mode === "shortest") {
        // --- 1. SHORTEST PATH LOGIC ---
        const targetM1 = (currentRotation - 1) + targetUnit; 
        const target0  = currentRotation + targetUnit;
        const target1  = (currentRotation + 1) + targetUnit; 

        const distM1 = Math.abs(current - targetM1); 
        const dist0  = Math.abs(current - target0);  
        const dist1  = Math.abs(current - target1);  

        finalTargetValue = target0;
        if (distM1 < dist0 && distM1 < dist1) {
            finalTargetValue = targetM1;
        } else if (dist1 < dist0) {
            finalTargetValue = target1;
        }
    } 
    else if (mode === "forward") {
        // --- 2. FORWARD ONLY LOGIC ---
        // Calculate target in the current rotation
        let target = currentRotation + targetUnit;
        
        // If the calculated target is behind us (or equal), 
        // add 1 full circle to make it the 'next' occurrence.
        if (target <= current) {
            target += 1;
        }
        finalTargetValue = target;
    }

    gsap.to(App.progress, {
      duration: 1.5, 
      ease: "power2.out",
      value: finalTargetValue
    });
  }
} */

function goToChapter(chapterId) {
  const chapter = chapters.find(c => c.id === chapterId);
  if (chapter) {
    const current = App.progress.value;
    const targetUnit = chapter.startProgress; 

    // Determine the current integer loop (e.g., 5.0)
    const currentRotation = Math.floor(current); 
    
    // Default Target: The specific spot in the CURRENT loop (e.g., 5.2)
    const target0 = currentRotation + targetUnit;
    let finalTargetValue = target0; 

    // Check Config Direction
    const mode = config.chapters.dir || "shortest";

    if (mode === "shortest") {
        // --- 1. SHORTEST PATH (WRAP ENABLED) ---
        // Check if going to the previous or next loop is closer than staying linear
        const targetM1 = (currentRotation - 1) + targetUnit; 
        const target1  = (currentRotation + 1) + targetUnit; 

        const distM1 = Math.abs(current - targetM1); 
        const dist0  = Math.abs(current - target0);  
        const dist1  = Math.abs(current - target1);  

        if (distM1 < dist0 && distM1 < dist1) {
            finalTargetValue = targetM1; // Wrap Backward
        } else if (dist1 < dist0) {
            finalTargetValue = target1;  // Wrap Forward
        }
    } 
    else if (mode === "bounded") {
        // --- 2. BOUNDED (LINEAR / NO WRAP) ---
        // We do nothing extra. We stick to 'target0'.
        // If we are at 0.9 and go to 0.1:
        // Shortest would wrap to 1.1 (dist 0.2).
        // Bounded forces us back to 0.1 (dist 0.8), preventing the boundary cross.
        finalTargetValue = target0;
    }

    gsap.to(App.progress, {
      duration: 1.5, 
      ease: "power2.out",
      value: finalTargetValue
    });
  }
}

/* function updateChapterUI() {
  if (chapters.length === 0) return;

  const wrappedProgress = gsap.utils.wrap(0, 1, App.progress.value);
  const currentImageIndex = Math.floor(wrappedProgress * App.layout.numImages);
  
  let activeChapter = chapters[0]; 
  for (let i = 0; i < chapters.length; i++) {
    if (currentImageIndex >= chapters[i].startIndex) {
      activeChapter = chapters[i];
    } else {
      break; 
    }
  }

  if (activeChapter.id === lastActiveChapterId) {
    return;
  }

  if (lastActiveChapterId !== null) {
    const oldChapter = chapters.find(c => c.id === lastActiveChapterId);
    if (oldChapter) {
      oldChapter.markerElems.line.circle?.classList.remove('circle-active');
      oldChapter.markerElems.line.text?.classList.remove('text-active');
      oldChapter.markerElems.circle.circle?.classList.remove('circle-active');
      oldChapter.markerElems.circle.text?.classList.remove('text-active');
    }
  }
  
  activeChapter.markerElems.line.circle?.classList.add('circle-active');
  activeChapter.markerElems.line.text?.classList.add('text-active');
  activeChapter.markerElems.circle.circle?.classList.add('circle-active');
  activeChapter.markerElems.circle.text?.classList.add('text-active');

  if (lineChapterText) {
    lineChapterText.textContent = activeChapter.name;
  }
  
  lastActiveChapterId = activeChapter.id;
} */

function updateChapterUI() {
  if (chapters.length === 0) return;

  const wrappedProgress = gsap.utils.wrap(0, 1, App.progress.value);
  const currentImageIndex = Math.floor(wrappedProgress * App.layout.numImages);
   
  let activeChapter = chapters[0]; 
  for (let i = 0; i < chapters.length; i++) {
    if (currentImageIndex >= chapters[i].startIndex) {
      activeChapter = chapters[i];
    } else {
      break; 
    }
  }

  // Check against the OBJECT, not the ID
  if (activeChapter === lastActiveChapter) {
    return;
  }

  // Deactivate the stored object directly
  if (lastActiveChapter) {
      lastActiveChapter.markerElems.line.circle?.classList.remove('circle-active');
      lastActiveChapter.markerElems.line.text?.classList.remove('text-active');
      lastActiveChapter.markerElems.circle.circle?.classList.remove('circle-active');
      lastActiveChapter.markerElems.circle.text?.classList.remove('text-active');
  }
   
  // Activate the new object
  activeChapter.markerElems.line.circle?.classList.add('circle-active');
  activeChapter.markerElems.line.text?.classList.add('text-active');
  activeChapter.markerElems.circle.circle?.classList.add('circle-active');
  activeChapter.markerElems.circle.text?.classList.add('text-active');

  if (lineChapterText) {
    lineChapterText.textContent = activeChapter.name;
  }
   
  // Store the OBJECT reference
  lastActiveChapter = activeChapter;
}

//////////////// SOUND TOGGLE //////////////////
function setupSoundTooltip() {
	
/* 	const tooltipSVG = MakeSvgEl("svg", { class: "soundtooltip" });
lineSVG.before(tooltipSVG); */


    const tooltip = document.querySelector(".soundtooltip");

    if (!tooltip) return; // safety

    // --- STYLE THE SVG ---
/*     tooltip.setAttribute("width", "100%");
    tooltip.setAttribute("height", "40");
 //   tooltip.style.left = "50%";
  //  tooltip.style.transform = "translateX(-50%)";
    tooltip.style.opacity = "0";
    tooltip.style.transition = "opacity .4s ease";
    tooltip.style.pointerEvents = "none"; */
    tooltip.style.position = "absolute";
    tooltip.style.bottom = "100%";
	
/* 	  tooltip.setAttribute("viewBox", "0 0 100 120");
  tooltip.setAttribute("width", "100");
  tooltip.setAttribute("height", "120"); */
	
  // -------------------------------
  // 2. BOX DIMENSIONS (FULL WIDTH)
  // -------------------------------
//  const boxX = -39;            // left edge of viewBox
  const boxX = -39+338;            // left edge of viewBox
  const boxY = 0;
  const boxW = 676/2;            // full width
  const boxH = 55;
  const boxRadius = 10;
  

  const box = document.createElementNS("http://www.w3.org/2000/svg", "rect");
  box.setAttribute("x", boxX);
  box.setAttribute("y", boxY);
  box.setAttribute("width", boxW);
  box.setAttribute("height", boxH);
  box.setAttribute("rx", boxRadius);
  box.setAttribute("ry", boxRadius);
  box.setAttribute("fill", "white");
  box.setAttribute("opacity", "0.95");
  tooltip.appendChild(box);
  
/*   const testl = MakeSvgEl('line',{ x1:0, y1:config.y12, x2:config.x2, y2:config.y12 });
testl.setAttribute("stroke", "blue");
testl.setAttribute("stroke-width", 5);
  tooltip.appendChild(testl); */

  // -------------------------------
  // 3. TRIANGLE — CENTER POSITION BY JS
  // -------------------------------
  const centerX = config.x2;
//  const centerX = 636;
  const triWidth = 30;
  const triHeight = 22;

  const triLeft = centerX - triWidth / 2;
  const triRight = centerX + triWidth / 2;
  const triTipY = boxH + triHeight; // below the rectangle

  const tri = document.createElementNS("http://www.w3.org/2000/svg", "path");
  tri.setAttribute("d", `
    M ${triLeft} ${boxH}
    Q ${centerX} ${triTipY} ${triRight} ${boxH}
  `);
  tri.setAttribute("fill", "white");
  tri.setAttribute("opacity", "0.95");
  tooltip.appendChild(tri);
  

    // --- DRAW TEXT ---
//    const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
/*     text.setAttribute("x", "50%");
    text.setAttribute("y", "50%"); */
	const text = MakeSvgEl('text',{ x:boxX + boxW/2, y:boxH/2, textContent: "Enable sound for narration"});
    text.setAttribute("dominant-baseline", "middle");
    text.setAttribute("text-anchor", "middle");
    text.setAttribute("font-size", "1.5em");
    text.setAttribute("font-family", "monospace");
    text.setAttribute("fill", "#192022");
//    text.textContent = "Enable sound for narration";
	/* const text = MakeSvgEl('text',{ x:xPos, y:boxY, textContent: "Enable sound for narration", class:config.chapters.IconTxtClass }); */
    tooltip.appendChild(text);
    // --- LOCAL STORAGE EXPIRY SYSTEM ---
    const KEY = "hasSeenSoundTooltip";
    const EXPIRY_DAYS = 0;
    const now = Date.now();

    let stored = localStorage.getItem(KEY);

    // Determine if tooltip should be shown
    let show = false;

    if (!stored) {
        // never shown before
        show = true;
    } else {
        const data = JSON.parse(stored);
        if (now > data.expires) {
            // expired → show again
            show = true;
        }
    }

    if (show) {
        // --- SHOW TOOLTIP ---
 //       tooltip.style.opacity = "1";
		tooltip.classList.remove("skrj");

        // --- HIDE AFTER 5s ---
        setTimeout(() => {
        //    tooltip.style.opacity = "0";
			tooltip.classList.add("skrj");
        }, 5000);

        // --- SET NEW EXPIRY ---
        localStorage.setItem(KEY, JSON.stringify({
            seen: true,
//            expires: now + EXPIRY_DAYS * 24 * 60 * 60 * 1000
            expires: now + 10000
        }));
    }
	ButtonTooltip = tooltip;

}

function setupSoundMarker() {
  const xPos = config.x2; 
  const yPos = config.y12; 
  const tapRadius = config.y12; 
  const visualRadius = config.y12 / 1.2; 

  const group = MakeSvgEl('g',{class:'sound-marker-group' });      
  const circle = MakeSvgEl('circle',{ r:tapRadius, cx:xPos, cy:yPos, class:'chapter-marker-circle' });  
  const circleic = MakeSvgEl('circle',{ r:visualRadius, cx:xPos, cy:yPos, class:'sound-on' });
  const circleic_trns = MakeSvgEl('circle',{ r:visualRadius, cx:xPos, cy:yPos, class:'sound-off show hide' });

  const soundicon = 2;
  
  let IconRelativeScale = 0.5;
  let WavesRelativeScale = 0.9;
  let WavesYoffset = -3;
  let WavesXoffset = 0;
  let WavesRadius = 4.5;

  if(soundicon===1){WavesYoffset = -6;WavesRadius = 4.5;IconRelativeScale = 0.5;WavesRelativeScale = 0.8;}
  if(soundicon===3){WavesYoffset = 0;WavesXoffset = 4;WavesRadius = 4.5;IconRelativeScale = 0.5;WavesRelativeScale = 0.8;}
  if(soundicon===4){WavesYoffset = 0;WavesXoffset = 4;WavesRadius = 4.5;IconRelativeScale = 0.5;WavesRelativeScale = 0.8;}
  if(soundicon===5){WavesYoffset = 0;WavesXoffset = 0;WavesRadius = 4.5;IconRelativeScale = 0.3;WavesRelativeScale = 1;}
  if(soundicon===6){WavesYoffset = 0;WavesXoffset = 0;WavesRadius = 4.5;IconRelativeScale = 0.3;WavesRelativeScale = 1;}
  
  const iconScale = visualRadius * IconRelativeScale/10; 
  
  const soundcircle1 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
  soundcircle1.setAttribute("cx", xPos);
  soundcircle1.setAttribute("cy", yPos); 
  soundcircle1.setAttribute("r", `${WavesRelativeScale*WavesRadius/3}%`); 
  soundcircle1.classList.add("sound-circle-1"); 
  const soundcircle2 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
  soundcircle2.setAttribute("cx", xPos);
  soundcircle2.setAttribute("cy", yPos); 
  soundcircle2.setAttribute("r", `${WavesRelativeScale*WavesRadius/1.5}%`); 
  soundcircle2.classList.add("sound-circle-2");
  const soundcircle3 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
  soundcircle3.setAttribute("cx", xPos);
  soundcircle3.setAttribute("cy", yPos); 
  soundcircle3.setAttribute("r", `${WavesRelativeScale*WavesRadius}%`); 
  soundcircle3.classList.add("sound-circle-3");
  
  const circles = [soundcircle1,soundcircle2,soundcircle3];  
  const soundanim = createWaveAnimation(circles,gsap.timeline({paused: true, repeat: -1,defaults: {duration: 1,ease: 'none'}}),1); 
  
const pica1 = document.createElementNS("http://www.w3.org/2000/svg", "path");  
pica1.setAttribute("d", "M0 0-70 70A99 99 0 0 1-70-70Z");
pica1.classList.add("maskfill");
pica1.setAttribute("transform", `translate(${xPos}, ${yPos}) scale(${WavesRelativeScale*visualRadius/100})`);

const pica2 = document.createElementNS("http://www.w3.org/2000/svg", "path");  
pica2.setAttribute("d", "M0 0-70-70A99 99 0 0 1 70-70Z");
pica2.classList.add("maskfill");
pica2.setAttribute("transform", `translate(${xPos}, ${yPos}) scale(${WavesRelativeScale*visualRadius/100})`);

const pica3 = document.createElementNS("http://www.w3.org/2000/svg", "path");  
pica3.setAttribute("d", "M0 0 70-70A99 99 0 0 1 70 70Z");
pica3.classList.add("maskfill");
pica3.setAttribute("transform", `translate(${xPos}, ${yPos}) scale(${WavesRelativeScale*visualRadius/100})`);

const pica4 = document.createElementNS("http://www.w3.org/2000/svg", "path");  
pica4.setAttribute("d", "M0 0 70 70A99 99 0 0 1-70 70Z");
pica4.classList.add("maskfill");
pica4.setAttribute("transform", `translate(${xPos}, ${yPos}) scale(${WavesRelativeScale*visualRadius/100})`);

const wavesgroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
wavesgroup.appendChild(soundcircle1);
wavesgroup.appendChild(soundcircle2);
wavesgroup.appendChild(soundcircle3);
if(soundicon===1 || soundicon===2 || soundicon===3 || soundicon===4 || soundicon===5 || soundicon===6){
wavesgroup.appendChild(pica2);
wavesgroup.appendChild(pica4);
}
if(soundicon===3 || soundicon===4){
wavesgroup.appendChild(pica1);
}
wavesgroup.setAttribute("transform", `translate(${WavesXoffset}, ${WavesYoffset}) `);


const chalice = document.createElementNS("http://www.w3.org/2000/svg", "path");
  
  if(soundicon===1){chalice.setAttribute("d", "M -3 -9 V 0 C -3 4, 3 4, 3 0 V -9 M 0 4 V 8 M -5 8 H 5");}
  if(soundicon===2){chalice.setAttribute("d", "M -4 2 V -6 A 4 4 0 0 1 4 -6 V 2 A 4 4 0 0 1 -4 2 M -5 6 M 0 6 V 10 M -4 10 H 4");}
  if(soundicon===3){chalice.setAttribute("d", "M -5 -3 L -2 -3 L -2 3 L -5 3 Z M -2 -3 L 5 -6 L 5 6 L -2 3 Z");}
  if(soundicon===4){chalice.setAttribute("d", "M-2.777,11.203c0-0.033,0-0.066,0-0.099c0-1.723,0-3.445,0.002-5.168 c0-0.078-0.021-0.128-0.086-0.17c-0.093-0.06-0.185-0.121-0.27-0.192c-0.295-0.248-0.402-0.576-0.402-0.951 c0-0.955-0.021-1.909-0.001-2.863C-3.517,0.875-3.468-0.008-3.41-0.89c0.081-1.242,0.26-2.473,0.532-3.688 c0.326-1.455,0.791-2.861,1.457-4.198c0.294-0.589,0.662-1.127,1.156-1.569c0.603-0.541,1.31-0.843,2.12-0.861 c0.243-0.005,0.49,0.068,0.731,0.123C2.657-11.067,2.727-11,2.777-10.939c0.264,0.326,0.399,0.713,0.505,1.111 c0.164,0.616,0.232,1.246,0.255,1.882c0.022,0.643-0.012,1.281-0.12,1.916c-0.073,0.427-0.18,0.845-0.38,1.234 C2.823-4.379,2.573-4.214,1.982-4.265C1.813-4.28,1.647-4.337,1.479-4.368C0.954-4.465,0.538-4.279,0.211-3.87 c-0.259,0.324-0.398,0.707-0.53,1.093c-0.3,0.874-0.501,1.772-0.625,2.686C-1.053,0.715-1.141,1.525-1.23,2.334 c-0.044,0.404-0.076,0.811-0.102,1.216C-1.352,3.85-1.338,4.151-1.364,4.449c-0.047,0.542-0.291,0.974-0.766,1.26 C-2.264,5.79-2.339,5.886-2.34,6.061c-0.006,0.792-0.033,1.584-0.044,2.377c-0.01,0.708-0.042,1.413-0.197,2.105 c-0.05,0.223-0.115,0.442-0.173,0.664C-2.763,11.205-2.77,11.204-2.777,11.203z M1.708-10.871c-0.565,0.057-1.069,0.248-1.517,0.583 C-0.321-9.906-0.698-9.411-1-8.857c-0.464,0.85-0.808,1.751-1.102,2.672c-0.553,1.732-0.849,3.513-0.979,5.321 C-3.15,0.096-3.18,1.06-3.208,2.022C-3.227,2.663-3.212,3.305-3.21,3.946c0,0.259,0.004,0.519,0.012,0.777 c0.007,0.224,0.084,0.422,0.258,0.569c0.11,0.093,0.229,0.178,0.352,0.254c0.031,0.019,0.097,0.004,0.135-0.016 c0.069-0.036,0.128-0.09,0.194-0.133c0.243-0.161,0.425-0.375,0.496-0.658c0.051-0.2,0.09-0.41,0.091-0.615 c0.004-0.579,0.026-1.155,0.098-1.729c0.108-0.858,0.193-1.719,0.309-2.576c0.12-0.896,0.319-1.775,0.608-2.632 c0.133-0.395,0.27-0.789,0.512-1.134c0.394-0.563,0.916-0.855,1.619-0.76c0.074,0.01,0.147,0.025,0.225,0.039 C2.489-6.737,2.407-8.799,1.708-10.871z M2.062-10.862C2.747-8.754,2.807-6.67,2.027-4.593C2.289-4.55,2.571-4.608,2.706-4.868 c0.129-0.249,0.229-0.505,0.297-0.775c0.142-0.563,0.201-1.136,0.212-1.715c0.016-0.786-0.04-1.564-0.232-2.329 c-0.09-0.356-0.207-0.702-0.425-1.004c-0.027-0.037-0.062-0.083-0.102-0.093C2.333-10.817,2.206-10.835,2.062-10.862z");}
  
  chalice.classList.add("pitch");
  chalice.setAttribute("transform", `translate(${xPos}, ${yPos}) scale(${iconScale})`);
  
  if(!App.sound.soundon){circleic_trns.classList.remove('hide');chalice.classList.add('icon-off');}; 
  
  // Assign to the variables defined at the TOP
  soundMarkerIcon = circleic;
  ButtonIcon = chalice;
  soundAnim = soundanim;
  WavesGroup = wavesgroup;
  ButtonCover = circleic_trns;
  
  group.appendChild(circle);
  group.appendChild(circleic);
  group.appendChild(wavesgroup);
  group.appendChild(circleic_trns);
  group.appendChild(chalice);
  lineSVG.appendChild(group);

  group.addEventListener('click', toggleSound);
}


function toggleSound() {
  App.sound.soundon = !App.sound.soundon;
  
  if (soundMarkerIcon) {
    if (App.sound.soundon) {
     ButtonIcon.classList.remove('icon-off');
     ButtonCover.classList.add('hide');
     soundAnim.play();ButtonTooltip.classList.add("skrj");
     App.sound.soundon = true; App.sound.main.play();
    } else {
      ButtonIcon.classList.add('icon-off');
      ButtonCover.classList.remove('hide');
     soundAnim.pause();
     App.sound.soundon = false; App.sound.main.pause();
    }
  }
  
  if (soundWavePath_on && soundWavePath_off) {
    if (App.sound.soundon) {
      soundWavePath_on.style.display = "block";
      soundWavePath_off.style.display = "none";
    } else {
      soundWavePath_on.style.display = "none";
      soundWavePath_off.style.display = "block";
    }
  }  
}

///////////////////////// MODULE LOGIC AND CODE END /////////////////////////

/*   if (typeof document !== 'undefined') {
      const stylePath = "./library/navbar/line_1.css";
      if (!document.querySelector(`link[href="${stylePath}"]`)) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = stylePath;
        document.head.appendChild(link);
      }
      
      const stylePath_chapters = "./library/navbar/chapters_1.css";
      if (!document.querySelector(`link[href="${stylePath_chapters}"]`) && chapterElements.length > 0) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = stylePath_chapters;
        document.head.appendChild(link);
      }
      
      const stylePath_sound = "./library/navbar/sound_1.css";
      if (!document.querySelector(`link[href="${stylePath_sound}"]`) && chapterElements.length > 0) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = stylePath_sound;
        document.head.appendChild(link);
      }
  } */


//console.log('navbar done');
//lineSVG?.classList.remove('hide');
  return { config, updateLineProgress };
}